
import { useCallback } from 'react';
import type { GameData } from './types';

export const useGameDataStorage = (userData: any) => {
  const getStorageKey = useCallback(() => {
    const userEmail = userData?.email || 'guest';
    return `treasures_djibouti_${userEmail}`;
  }, [userData?.email]);

  /**
   * Load data from localStorage as cache
   */
  const loadFromLocalStorage = useCallback((): GameData | null => {
    try {
      const storageKey = getStorageKey();
      const savedData = localStorage.getItem(storageKey);
      if (savedData) {
        const parsed = JSON.parse(savedData) as GameData;
        console.log('🎮 Game Data - Loaded from localStorage:', parsed);
        return parsed;
      }
      return null;
    } catch (error) {
      console.error('🎮 Game Data - Error loading from localStorage:', error);
      return null;
    }
  }, [getStorageKey]);

  /**
   * Save data to localStorage as cache
   */
  const saveToLocalStorage = useCallback((data: GameData) => {
    try {
      const storageKey = getStorageKey();
      const dataWithTimestamp: GameData = { ...data, lastSyncTime: Date.now() };
      localStorage.setItem(storageKey, JSON.stringify(dataWithTimestamp));
      console.log('🎮 Game Data - Saved to localStorage');
    } catch (error) {
      console.error('🎮 Game Data - Error saving to localStorage:', error);
    }
  }, [getStorageKey]);

  return {
    loadFromLocalStorage,
    saveToLocalStorage
  };
};
